const accessToken =
  "test"
export default accessToken
